import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';
import {useSearchParams} from '../../../router/compat';

interface Props {
	onClearFilters: () => void;
}

const FILTER_PARAMS = ['status', 'priority', 'assignee_id', 'search'];

const Wrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 64px 0;
	text-align: center;
`;
const EmptyIcon = styled.svg`
	margin-bottom: 16px;
	height: 48px;
	width: 48px;
	color: ${p => p.theme.ticketing.color.dark100};
`;
const Title = styled.p`
	font: ${p => p.theme.ticketing.font.subheading2};
	color: ${p => p.theme.ticketing.color.dark700};
	margin: 0;
`;
const Subtitle = styled.p`
	margin: 4px 0 0;
	font: ${p => p.theme.ticketing.font.subheading2};
	color: ${p => p.theme.ticketing.color.dark500};
`;
const ClearButtonWrap = styled.div`
	margin-top: 16px;
`;

export function TicketListEmpty({onClearFilters}: Props) {
	const [searchParams] = useSearchParams();

	const hasActiveFilters = FILTER_PARAMS.some(key => searchParams.has(key));

	if (hasActiveFilters) {
		return (
			<Wrap>
				<EmptyIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
					/>
				</EmptyIcon>
				<Title>No tickets match your current filters</Title>
				<Subtitle>Try adjusting your search or filter criteria</Subtitle>
				<ClearButtonWrap data-testid="clear-filters-wrap">
					<Button emphasis={EMPHASIS.MEDIUM} onPress={onClearFilters}>
						Clear filters
					</Button>
				</ClearButtonWrap>
			</Wrap>
		);
	}

	return (
		<Wrap>
			<EmptyIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
				/>
			</EmptyIcon>
			<Title>No tickets yet</Title>
			<Subtitle>Create your first ticket to get started</Subtitle>
		</Wrap>
	);
}
